module.exports = __webpack_public_path__ + "img/img3.23faa6b7.png";